import { toast } from '@itsrever/design-system'
import { useTranslation } from 'react-i18next'
import { OpspbRefundOverride } from '@itsrever/rever-api'
import { promiseTimer } from '@/utils'
import posthog from 'posthog-js'
import { NewReview } from '@/domain/review'
import { createReview } from '@/infrastructure/api/ops'
import { useProcessAction } from './use-process-action'

interface ReviewRequest {
  processId: string
  reviews: NewReview[]
  refundOverride: OpspbRefundOverride
}

export function useCreateReviews(differenceRefundAmount?: number) {
  const { t } = useTranslation()
  return useProcessAction({
    action: ({ processId, reviews, refundOverride }: ReviewRequest) => {
      const review = createReview(processId, reviews, refundOverride)
      if (!reviews.some((r) => r.shouldRestock)) return review
      return Promise.all([review, promiseTimer(5)])
    },
    errorText: t('review_toast.error'),
    reloadAfterMs: 2000,
    onSuccess: (_, { reviews }) => {
      posthog.capture('Review', {
        hasRestock: reviews.some((r) => r.shouldRestock),
        restockQuantity: reviews.filter((r) => r.shouldRestock).length,
        defaultLocationsQuantity: reviews.filter(
          (r) => r.shouldRestock && r.location?.isDefault
        ).length,
        hasLocation: reviews.some((r) => r.location?.id),
        editedRefundAmount: differenceRefundAmount
          ? -differenceRefundAmount
          : undefined
      })
      toast({
        variant: 'info',
        text: t('review_toast.success1')
      })
    }
  })
}
